import React, { forwardRef, ReactNode } from 'react'
import { HTMLMotionProps, motion } from 'framer-motion'
import { transitionService, TransitionType } from '@coachmate/common'

type Props = {
  children?: ReactNode
  className?: string
  transition: TransitionType
}

export const TransitionContainer = forwardRef<HTMLDivElement, Props>(({ children, className, transition }, ref) => {
  const additionalProps: HTMLMotionProps<'div'> = {}

  return (
    <motion.div className={className} {...transitionService.getTransitionConfig(transition)} {...additionalProps} ref={ref}>
      {children}
    </motion.div>
  )
})
